var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "TickerPopover",
    {
      attrs: {
        title: _vm.$t("Notification"),
        width: 360,
        left: _vm.left,
        "arrow-left": _vm.arrowLeft,
      },
      on: {
        close: function ($event) {
          return _vm.$emit("close")
        },
      },
    },
    [
      _c(
        "ul",
        { staticClass: "notification-popover__list" },
        _vm._l(_vm.announcements, function (notification, index) {
          return _c(
            "li",
            {
              key: `${index}${notification.publishDateTime}`,
              staticClass: "notification-popover__item",
              class: { latest: index === 0 },
            },
            [
              _c("div", { staticClass: "notification-popover__time" }, [
                _vm._v(
                  _vm._s(_vm.renderDateTime(notification.publishDateTime))
                ),
              ]),
              _c("p", { staticClass: "notification-popover__message" }, [
                _vm._v(_vm._s(notification.message)),
              ]),
            ]
          )
        }),
        0
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }